import { Component, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { benchmarkMinutesToMs, benchmarkMsToMinutes } from './benchmark-minutes';

@Component({
  selector: 'app-benchmark-minutes',
  template: `<input type="text" inputmode="decimal" class="form-control" aria-label="Minutes per action"
    [value]="minutes" [disabled]="disabled" (input)="edit($any($event.target).value)" (blur)="touch()">
    <small>0 excludes this action from Weighted Work Minutes. Edited values are saved to the nearest millisecond.</small>
    <p *ngIf="error" class="text-danger" role="alert">{{error}}</p>`,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BenchmarkMinutesComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => BenchmarkMinutesComponent), multi: true }
  ]
})
export class BenchmarkMinutesComponent implements ControlValueAccessor, Validator {
  minutes = '0';
  error = '';
  disabled = false;
  private change: (value: number) => void = () => {};
  touch: () => void = () => {};
  private validationChange: () => void = () => {};

  writeValue(ms: number | string | null): void {
    // Do not emit a conversion on load: untouched values retain their exact original milliseconds.
    try { this.minutes = benchmarkMsToMinutes(ms); this.error = ''; }
    catch { this.minutes = String(ms ?? ''); this.error = 'The stored duration is invalid.'; }
  }
  edit(value: string): void {
    this.minutes = value;
    try { const ms = benchmarkMinutesToMs(value); this.error = ''; this.change(ms); }
    catch (error) { this.error = error.message; }
    this.validationChange();
  }
  registerOnChange(fn: (value: number) => void): void { this.change = fn; }
  registerOnTouched(fn: () => void): void { this.touch = fn; }
  registerOnValidatorChange(fn: () => void): void { this.validationChange = fn; }
  setDisabledState(disabled: boolean): void { this.disabled = disabled; }
  validate(_: AbstractControl): ValidationErrors | null { return this.error ? { benchmarkMinutes: this.error } : null; }
}
